import { useGLTF, useTexture } from '@react-three/drei';
import { DecalGeometry } from 'three/examples/jsm/geometries/DecalGeometry';
import { useEffect, useMemo, useState } from 'react';
import * as THREE from 'three';
// import { useSurfaceDrag } from "hooks/useSurfaceDrag";

import { useRecoilValue, useSetRecoilState } from 'recoil';
import { logoTransformState } from 'state/langState';
import { getSafeTransform } from 'utils/getText';
import { useSurfaceDrag } from 'hooks/useSurfacePosition';

export default function BookDecalLogo({ logo, product }) {
  const { scene } = useGLTF('/obj/book.glb');
  const setTransforms = useSetRecoilState(logoTransformState);
  const texture = useTexture(logo);

  const transforms = useRecoilValue(logoTransformState);

  const transform = getSafeTransform(transforms, product);

  const [decalGeometry, setDecalGeometry] = useState(null);
  // console.log(logoTransformState);

  /* mesh 찾기 */
  // console.log(transform.position);
  const targetMesh = useMemo(() => {
    let mesh = null;

    scene.traverse((child) => {
      console.log(child.name);
      if (child.name === 'kaft_R_01') {
        mesh = child;
      }
      // if (child.isMesh && !mesh) {
      //   mesh = child;
      // }
    });

    return mesh;
  }, [scene]);

  useSurfaceDrag({
    targetMesh,

    onMove: ({ point }) => {
      setTransforms((prev) => ({
        ...prev,

        [product]: {
          ...prev[product],

          position: {
            x: point.x,
            y: point.y,
          },
        },
      }));
    },
  });
  /* texture 안정화 */

  useMemo(() => {
    if (!texture) return;

    texture.flipY = false;

    texture.wrapS = THREE.ClampToEdgeWrapping;

    texture.wrapT = THREE.ClampToEdgeWrapping;

    texture.needsUpdate = true;
  }, [texture]);

  /* decal 생성 */

  useEffect(() => {
    if (!targetMesh) return;

    /* 반드시 world matrix 업데이트 */

    targetMesh.updateWorldMatrix(true, true);

    const { x, y } = transform.position;

    const depth = transform.depth;

    const scale = transform.scale;

    /*
      world 기준 ray origin
    */

    const rayOrigin = new THREE.Vector3(-x, y, -5);

    const direction = new THREE.Vector3(0, 0, 1);

    const raycaster = new THREE.Raycaster(rayOrigin, direction);

    const intersects = raycaster.intersectObject(targetMesh, true);

    if (!intersects.length) return;

    const hit = intersects[0];

    /*
      normal 계산
    */

    const normal = hit.face.normal.clone();

    normal.transformDirection(hit.object.matrixWorld);

    /*
      depth 적용
    */

    const finalPosition = hit.point.clone().add(normal.multiplyScalar(depth));

    /*
      핵심: normal 기반 rotation
    */

    const quaternion = new THREE.Quaternion();

    quaternion.setFromUnitVectors(new THREE.Vector3(0, 0, 1), normal);

    const rotation = new THREE.Euler().setFromQuaternion(quaternion);
    rotation.z += Math.PI;
    /*
      size
    */

    const size = new THREE.Vector3(scale, scale, scale);

    const geometry = new DecalGeometry(
      targetMesh,
      finalPosition,
      rotation,
      size
    );

    setDecalGeometry((prev) => {
      if (prev) prev.dispose();
      return geometry;
    });

    return () => {
      geometry.dispose();
    };
  }, [targetMesh, texture, transform]);

  return (
    <>
      <primitive object={scene} scale={0.2} position={[1, 0, 0]} />

      {decalGeometry && (
        <mesh key={JSON.stringify(transform)} geometry={decalGeometry}>
          <meshStandardMaterial
            map={texture}
            transparent
            depthWrite={false}
            polygonOffset
            polygonOffsetFactor={-4}
          />
        </mesh>
      )}
    </>
  );
}

useGLTF.preload('/obj/book.glb');
